var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"copy-link",class:{'copy-link__clicked': _vm.clicked},attrs:{"href":_vm.link,"rel":"noopener noreferrer"},on:{"click":function($event){$event.preventDefault();return _vm.copyLink($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }